var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctorPatientOnline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    id: "svg5419",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5423"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 524.67071,259.23232",
    id: "path9804"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 686.41616,851.91111",
    id: "path9800"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M511.741414 585.309091c49.777778 0 95.288889 10.084848 135.369697 29.866667 37.882828 18.747475 70.723232 46.157576 97.745455 81.454545 26.117172 34.262626 46.416162 75.377778 60.250505 122.311111 12.282828 42.149495 19.135354 87.789899 20.428283 136.145455H198.076768c1.292929-48.355556 8.016162-93.99596 20.428283-136.145455 13.705051-46.80404 34.00404-88.048485 60.250505-122.311111 27.022222-35.29697 59.862626-62.707071 97.745454-81.454545 39.822222-19.911111 85.333333-29.866667 135.240404-29.866667m0-15.515152C296.468687 569.793939 182.30303 749.123232 182.30303 970.472727h658.747475c0-221.349495-114.165657-400.678788-329.309091-400.678788z m0 0",
    fill: "",
    id: "path5409",
    style: {
      stroke: "#000000",
      strokeOpacity: 1,
      strokeWidth: 23,
      strokeDasharray: "none"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 347.53939,327.75758",
    id: "path13677"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 514.97374,889.01818 c -8.01616,0 -14.48081,6.46465 -14.48081,14.48081 0,8.01616 6.46465,14.48081 14.48081,14.48081 8.01616,0 14.48081,-6.46465 14.48081,-14.48081 0,-8.01616 -6.46465,-14.48081 -14.48081,-14.48081 z",
    id: "path13671"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 518.61801,939.543 c -18.93183,0 -34.00001,-15.26136 -34.00001,-33.99999 0,-18.73863 15.26136,-34.00001 34.00001,-34.00001 18.93181,0 33.99999,15.26138 33.99999,34.00001 0,18.73863 -15.26136,34 -33.99999,33.99999 z",
    id: "path13669",
    style: {
      strokeWidth: 1.49414
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 514.97374,797.86667 c -8.01616,0 -14.48081,6.46464 -14.48081,14.48081 0,8.01616 6.46465,14.4808 14.48081,14.4808 8.01616,0 14.48081,-6.46464 14.48081,-14.4808 0.12929,-8.01617 -6.46465,-14.48081 -14.48081,-14.48081 z",
    id: "path13667"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 518.61711,857.71942 c -18.93125,0 -33.99911,-15.26099 -33.99911,-33.9991 0,-18.93125 15.26099,-33.99911 33.99911,-33.99911 18.93124,0 33.9991,15.26099 33.9991,33.99911 0.19313,18.54497 -15.26099,33.9991 -33.9991,33.9991 z",
    id: "path5411",
    style: {
      stroke: "none",
      strokeWidth: 20.9174,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 601.47071,742.91717",
    id: "path5435"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 514.97374,700.12121 c -50.68283,0 -91.92728,-41.24444 -91.92728,-91.92727 v -20.94546 h 8.27475 v 20.94546 c 0,46.15757 37.49495,83.65252 83.65253,83.65252 46.15757,10e-6 83.65252,-37.49494 83.65252,-83.65252 V 590.6101 h 8.27475 v 17.58384 c 0.12929,50.68283 -41.11515,91.92727 -91.92727,91.92727 z",
    id: "path5429",
    style: {
      stroke: "#000000",
      strokeOpacity: 1,
      strokeWidth: 14,
      strokeDasharray: "none",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 676.6859,323.28966 H 339.1641 V 123.50164 c 0,-13.3781 7.79467,-25.74655 19.79599,-31.299721 29.94147,-13.882933 89.4532,-37.105295 152.18176,-37.105295 62.48111,0 118.52856,22.969945 146.4904,36.852878 11.63016,5.679385 19.05365,17.921608 19.05365,31.047288 z",
    id: "path5413",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 24,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.290909 739.943434h-8.274747v-20.29899c0-7.757576-6.335354-13.963636-13.963637-13.963636s-13.963636 6.335354-13.963636 13.963636h-8.274748c0-12.282828 10.084848-22.238384 22.238384-22.238383 12.153535 0 22.238384 10.084848 22.238384 22.238383v20.29899z m0 0",
    fill: "",
    id: "path5415",
    style: {
      stroke: "#000000",
      strokeOpacity: 1,
      strokeWidth: 14,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.527273 773.688889c-30.125253 0-54.561616-24.565657-54.561616-54.561616v-23.014142h8.274747v23.014142c0 25.6 20.816162 46.286869 46.286869 46.286868 25.6 0 46.286869-20.816162 46.286868-46.286868h8.274748c0 29.99596-24.436364 54.561616-54.561616 54.561616z m0 0",
    fill: "",
    id: "path5417",
    style: {
      strokeWidth: 14,
      strokeDasharray: "none",
      stroke: "#000000",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 0,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 782.28837,370.30698 c 1.91,0.34447 28.05521,-0.52154 28.57675,0 0.28065,0.28065 -0.28065,0.91004 0,1.19069 1.1226,1.1226 3.17519,0 4.76279,0 13.49457,0 26.98914,0 40.48372,0 3.66065,0 16.28975,1.31737 20.24186,0 4.49185,-1.49728 0.8263,-2.38139 8.33488,-2.38139 3.94377,0 31.3509,3.97106 34.53023,2.38139 0.71,-0.35499 -0.35499,-1.6714 0,-2.38139 1.47135,-2.9427 1.1907,0.411 1.1907,-2.3814",
    id: "path16759"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g16797",
    transform: "matrix(1.3291161,0,0,1.3291161,-216.45513,-60.68811)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 26.596,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    d: "M 490.84604,193.11033 H 596.86428",
    id: "path16761"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      overflow: "hidden",
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 26.596,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    d: "M 543.80581,138.26278 V 244.28102",
    id: "path16761-8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 507.33865,546.99103 c 25.65776,0 49.11626,-5.19819 69.77576,-15.39464 19.52649,-9.6633 36.45397,-23.79171 50.38236,-41.98539 13.462,-17.66052 23.92513,-38.85314 31.05587,-63.04471 6.33126,-21.72577 9.86329,-45.25092 10.52968,-70.17558 H 345.66161 c 0.66643,24.92466 4.13189,48.44981 10.52967,70.17558 7.0642,24.12492 17.52723,45.38419 31.05585,63.04471 13.92847,18.19368 30.85591,32.32209 50.38248,41.98539 20.52613,10.26309 43.98463,15.39464 69.70904,15.39464 m 0,7.99721 c -110.96138,0 -169.80754,-92.43449 -169.80754,-206.5281 h 339.54843 c 0,114.09361 -58.8461,206.5281 -169.74089,206.5281 z m 0,0",
    fill: "",
    id: "path19093",
    style: {
      stroke: "#000000",
      strokeWidth: 24,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 14,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    id: "path24535",
    cx: 650.25757,
    cy: 776.72803,
    r: 33.138241
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorPatientOnline);
export default __webpack_public_path__ + "static/media/doctor-patient-online.c9dbc0b1edc4aa741c9f47111c99f144.svg";
export { ForwardRef as ReactComponent };